/*================================================================================================================
 MAIN CONTROLLER
 ================================================================================================================*/
 angular
 .module('vppApp')
 .controller('ForgotUsernameController', ForgotUsernameController);

 ForgotUsernameController.$inject = ['$scope', 'vppConfig', 'ForgotUsernameService','apiFactory', '$log', '$state', '$rootScope', 'dobFilter', 'AuthenticationService'];

 function ForgotUsernameController($scope, vppConfig, ForgotUsernameService, apiFactory, $log, $state, $rootScope, dobFilter, AuthenticationService) {

  if ($scope.siteCode === 'mpp' && $state.current.name === "forgot-username.step-2"){
    $state.go('forgot-username');
  }

  $scope.goStep2 = function() {

    $scope.serverError = '';

    var validateService = {
      accountDetails: {
        firstName: $scope.forgotUsernameFields.firstName,
        lastName: $scope.forgotUsernameFields.lastName,
        streetAddress: $scope.forgotUsernameFields.streetAddress,
        city: $scope.forgotUsernameFields.city,
        stateInclPR: $scope.forgotUsernameFields.stateInclPR,
        postalCode: $scope.forgotUsernameFields.postalCode,
        uscaPostalCode: $scope.forgotUsernameFields.uscaPostalCode,
        phoneNumber: $scope.forgotUsernameFields.phoneNumber,
        dateOfBirth: dobFilter($scope.forgotUsernameFields.dateOfBirth)
      }
    };



    ForgotUsernameService.addUName(validateService);

      // console.log("uName", validateService);
    apiFactory.forgotUsernameValidate(validateService).then(function(response){

      $rootScope.secretQuestion = response.data.securityQuestionCode;
      $state.go("forgot-username.step-2");

    },function errorCallback(response) {

        // $log.info(response.data.errors);
        $scope.serverError = response.data.errors;
        // called asynchronously if an error occurs
        // or server returns response with an error status.
        // console.log ('errorCode: ' + $scope.serverError);

      });
  };

  $scope.goStep3 = function() {
    var userInfo = ForgotUsernameService.getUname();
        userInfo.securityAnswer= $scope.forgotUsernameFields.securityAnswer;
     $scope.serverError = '';
    apiFactory.forgotUsername(userInfo).then(function(response){

      $scope.usernameResponse = response.data.username;
      $rootScope.usernameResponse = $scope.usernameResponse;

      $state.go('sign-in');

    },function errorCallback(response) {
      // $log.info(response.data.errors);
      $scope.serverError = response.data.errors;
      // called asynchronously if an error occurs
      // or server returns response with an error status.
      // console.log ('errorCode: ' + $scope.serverError);
    });
  };

  $scope.idMeFactoryCall = function() {
        apiFactory.idMeAccessUserData().then(function(response) {
            $scope.user = response.data;
            var accountId = response.data.accountID;
            var userEmail = response.data.email;
            var collectMoreInfo = response.data.requireAdditionalData;

            if (collectMoreInfo === true) {
                AuthenticationService.setAuthentication(response, userEmail);
                $state.go('create-account');
            } else{
                apiFactory.getProfileDetails(accountId).then(function(thisResponse) {
                    userEmail = thisResponse.data.customerDetails.emailAddress;
                    AuthenticationService.setAuthentication(response, userEmail);
                    $state.go('view-auth');
                });

            }

        }, function errorCallback(response) {
            // console.log(response.data.errors);
            $scope.serverError = response.data.errors;
            // called asynchronously if an error occurs
            // or server returns response with an error status.

        });
    };
}
